import { I as IMaskMixin, _ as _objectWithoutProperties } from './mixin-1cb78d9b.js';
import React from 'react';
import 'prop-types';
import 'imask/esm/imask';

var InputComponent = function InputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement('input', Object.assign({}, props, {
    ref: inputRef
  }));
};

var IMaskInput = IMaskMixin(InputComponent);

export default IMaskInput;
